import { useEffect, useState } from 'react';

import boxImg from '../../../../assets/icons/box.png';
import clockImg from '../../../../assets/icons/clock.png';
import fileImg from '../../../../assets/icons/file.png';
import markImg from '../../../../assets/icons/mark.png';
import timeImg from '../../../../assets/icons/time.png';
import seladHorse from '../../../../assets/map/seladHorse.png';

import {
  MarkerWrapper,
  Marker,
  Number,
  Info,
  HorseIcon,
} from './_locationMarker';

import { Invoice } from '../../../../Interfaces/RouteScripitingInterface';

interface MarkerProps {
  lat?: number;
  lng?: number;
  color?: string;
  order?: number | string;
  invoiceInfo: Invoice;
  seladBase?: boolean;
  showInvoiceInfo: string;
}

export const LocationMarker: React.FC<MarkerProps> = ({
  invoiceInfo,
  order,
  color = '#808080',
  seladBase = false,
  showInvoiceInfo,
}) => {
  const [showInfo, setShowInfo] = useState<boolean>(false);

  useEffect(() => {
    showInvoiceInfo === invoiceInfo.id ? setShowInfo(true) : setShowInfo(false);
  }, [showInvoiceInfo]);

  return (
    <MarkerWrapper
      onClick={() => setShowInfo(!showInfo)}
      className="marker-wrapper"
    >
      <Info color={color} showInfo={showInfo}>
        <div className="info__color-indicator">Rota</div>

        <h4>
          <strong>{invoiceInfo.client_name}</strong>
        </h4>

        <div className="info__loading-data-wrapper">
          <div className="info__loading-data-wrapper__info">
            <img width="15px" src={fileImg} />
            <strong>Número NF:</strong> {invoiceInfo.invoice_number}
          </div>

          <div className="info__loading-data-wrapper__info">
            <img width="15px" src={fileImg} />
            <strong>Número do Pedido:</strong> {invoiceInfo.order_number}
          </div>

          <div className="info__loading-data-wrapper__info">
            <img width="15px" src={markImg} />
            {invoiceInfo.address}
          </div>

          <div className="info__loading-data-wrapper__info">
            <img width="15px" src={clockImg} />
            <strong>CEP:</strong> {invoiceInfo.cep}
          </div>

          <div className="info__loading-data-wrapper__info">
            <img width="15px" src={boxImg} />
            <strong>Caixas:</strong> {invoiceInfo.amount_boxes}
          </div>

          <div className="info__loading-data-wrapper__info">
            <img width="15px" src={timeImg} />
            <strong>Cubagem:</strong> {(+invoiceInfo?.cubage || 0).toFixed(3)} m³
          </div>

          <div className="info__loading-data-wrapper__info">
            <img width="15px" src={boxImg} />
            <strong>Peso:</strong> {invoiceInfo.weight.toFixed(2)}
          </div>

          {/* <li>
              <img
                style={{ marginRight: '10px' }}
                width="15px"
                src={positionIcon}
              />

              <strong>Posições:</strong> 14-06-0000
            </li> */}

          {/* <li className="actionButtons">
              <div
                className="anchor__freeze"
                onClick={() => setShowModalFreeze(true)}
              >
                <img src={handIcon} style={{ marginRight: '12px' }} />
                Congelar
              </div>

              <div
                className="anchor__confirm-load"
                onClick={() => setShowModalLoad(true)}
              >
                <img src={loadIcon} style={{ marginRight: '12px' }} />
                Carregada
              </div>
            </li> */}
        </div>
      </Info>
      <Marker tagColor={`${color}`}>
        {seladBase ? (
          <HorseIcon src={seladHorse} alt="Sede Selad" />
        ) : (
          <Number tagColor={`${color}`}>{order}</Number>
        )}
      </Marker>
    </MarkerWrapper>
  );
};
